import React from "react";
import { Edges } from "@react-three/drei";
import { DoubleSide, Texture } from "three";
import { CORNICE, C_CORNICE, C_VETRO } from "./constants";

export type FinestraProps = {
  position: [number, number, number];
  spessore: number;
  finestraLarghezza: number;
  finestraAltezza: number;
  cornice: Texture | undefined;
  onRemove: () => void;
  isDoorClosed: boolean;
};

export const Finestra: React.FC<FinestraProps> = ({
  position,
  spessore,
  finestraLarghezza,
  finestraAltezza,
  cornice,
  onRemove,
  isDoorClosed,
}) => {
  const ε     = 0.0005;
  const vetroW = finestraLarghezza - CORNICE * 2;
  const vetroH = finestraAltezza   - CORNICE * 2;
  const halfW  = finestraLarghezza / 2;
  const halfH  = finestraAltezza   / 2;
  const halfC  = CORNICE / 2;
  const depth  = spessore + ε;

  const handleClick = (e: any) => { if (isDoorClosed) { e.stopPropagation(); onRemove(); } };
  const handleOver  = (e: any) => { if (isDoorClosed) { e.stopPropagation(); document.body.style.cursor = "pointer"; } };
  const handleOut   = ()       => { document.body.style.cursor = "default"; };

  return (
    <group position={position}>
      {/* Cornice superiore */}
      <mesh position={[0, halfH - halfC, 0]} onClick={handleClick} onPointerOver={handleOver} onPointerOut={handleOut}>
        <boxGeometry args={[finestraLarghezza + ε, CORNICE, depth]} />
        <meshStandardMaterial map={cornice} color={cornice ? undefined : C_CORNICE} />
      </mesh>
      {/* Cornice inferiore */}
      <mesh position={[0, -halfH + halfC, 0]} onClick={handleClick} onPointerOver={handleOver} onPointerOut={handleOut}>
        <boxGeometry args={[finestraLarghezza + ε, CORNICE, depth]} />
        <meshStandardMaterial map={cornice} color={cornice ? undefined : C_CORNICE} />
      </mesh>
      {/* Cornice sinistra */}
      <mesh position={[-halfW + halfC, 0, 0]} onClick={handleClick} onPointerOver={handleOver} onPointerOut={handleOut}>
        <boxGeometry args={[CORNICE, vetroH, depth]} />
        <meshStandardMaterial map={cornice} color={cornice ? undefined : C_CORNICE} />
      </mesh>
      {/* Cornice destra */}
      <mesh position={[halfW - halfC, 0, 0]} onClick={handleClick} onPointerOver={handleOver} onPointerOut={handleOut}>
        <boxGeometry args={[CORNICE, vetroH, depth]} />
        <meshStandardMaterial map={cornice} color={cornice ? undefined : C_CORNICE} />
      </mesh>

      {/* Vetro interno */}
      <mesh onClick={handleClick} onPointerOver={handleOver} onPointerOut={handleOut}>
        <boxGeometry args={[vetroW, vetroH, depth]} />
        <meshStandardMaterial
          color={C_VETRO}
          transparent
          opacity={0.28}
          roughness={0}
          metalness={0.15}
          side={DoubleSide}
        />
      </mesh>
    </group>
  );
};
